import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { DISCOUNT_CODE_CATEGORY_SUB_ENDPOINT } from '../../config/endpoints';
import {
  CLEAR_DISCOUNT_CODE_SUB_CATEGORIES,
  FLAG_GETTING_DISCOUNT_CODE_SUB_CATEGORIES,
  GET_DISCOUNT_CODE_SUB_CATEGORIES,
} from '../types';

const flagGettingDiscountCodeSubCategories = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DISCOUNT_CODE_SUB_CATEGORIES,
    payload: flag,
  });

const getDiscountCodeSubCategoriesByDiscountId =
  async (discountCodeId, tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDiscountCodeSubCategories(true));
      const query = tableFilters;
      const url = `${DISCOUNT_CODE_CATEGORY_SUB_ENDPOINT}/id/${discountCodeId}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const pricingProfiles = await response.json();
      dispatch({
        type: GET_DISCOUNT_CODE_SUB_CATEGORIES,
        payload: pricingProfiles,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingDiscountCodeSubCategories(false));
    }
  };

const getDiscountCodeSubCategoriesByDiscountString =
  async (discountCodeString, tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDiscountCodeSubCategories(true));
      const query = tableFilters;
      const url = `${DISCOUNT_CODE_CATEGORY_SUB_ENDPOINT}/code/${discountCodeString}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const pricingProfiles = await response.json();
      dispatch({
        type: GET_DISCOUNT_CODE_SUB_CATEGORIES,
        payload: pricingProfiles,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingDiscountCodeSubCategories(false));
    }
  };

const clearDiscountCodeSubCategories = () => (dispatch) =>
  dispatch({
    type: CLEAR_DISCOUNT_CODE_SUB_CATEGORIES,
  });

export {
  flagGettingDiscountCodeSubCategories,
  getDiscountCodeSubCategoriesByDiscountId,
  clearDiscountCodeSubCategories,
  getDiscountCodeSubCategoriesByDiscountString,
};
